var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-md-6 text-left\">\n<h1>Linked capacity</h1>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-md-12\">\n<pkp-capacity-linking-report-table></pkp-capacity-linking-report-table>\n</div>\n</div>\n";
var id1="app/capacity-linking-reporting/capacity-linking-report-overview.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;